<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Thumbnails" pageTitle="Thumbnails" />
            <ThumbnailsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ThumbnailsContent from '../Thumbnails/ThumbnailsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ThumbnailsPage',
    components: {
        MainHeader,
        PageTitle,
        ThumbnailsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>